
export interface Topic {
  id: string;
  title: string;
  status: "completed" | "in-progress" | "locked";
  description: string;
  minScore: number;
  category: string;
  subject: string;
  subcategories?: Topic[];
}

export const categories: Topic[] = [
  {
    id: "1",
    title: "JEE Genius (IIT-JEE, Mains & Advanced)",
    status: "in-progress",
    description: "Comprehensive preparation for JEE exams",
    minScore: 0,
    category: "JEE Genius",
    subject: "All",
    subcategories: [
      {
        id: "1.1",
        title: "Mathematics: Algebra",
        status: "in-progress",
        description: "Algebraic concepts and equations",
        minScore: 60,
        category: "JEE Genius",
        subject: "Mathematics: Algebra"
      },
      {
        id: "1.2",
        title: "Mathematics: Calculus",
        status: "locked",
        description: "Differential and integral calculus",
        minScore: 60,
        category: "JEE Genius",
        subject: "Mathematics: Calculus"
      },
      {
        id: "1.3",
        title: "Mathematics: Trigonometry",
        status: "locked",
        description: "Trigonometric functions and identities",
        minScore: 60,
        category: "JEE Genius",
        subject: "Mathematics: Trigonometry"
      },
      {
        id: "1.4",
        title: "Mathematics: Coordinate Geometry",
        status: "locked",
        description: "Points, lines, and shapes in coordinate systems",
        minScore: 60,
        category: "JEE Genius",
        subject: "Mathematics: Coordinate Geometry"
      },
      {
        id: "1.5",
        title: "Mathematics: Probability",
        status: "locked",
        description: "Probability theory and statistics",
        minScore: 60,
        category: "JEE Genius",
        subject: "Mathematics: Probability"
      },
      {
        id: "1.6",
        title: "Physics: Mechanics",
        status: "locked",
        description: "Classical mechanics and kinematics",
        minScore: 60,
        category: "JEE Genius",
        subject: "Physics: Mechanics"
      },
      {
        id: "1.7",
        title: "Physics: Thermodynamics",
        status: "locked",
        description: "Heat, energy, and thermodynamic processes",
        minScore: 60,
        category: "JEE Genius",
        subject: "Physics: Thermodynamics"
      },
      {
        id: "1.8",
        title: "Physics: Optics",
        status: "locked",
        description: "Light, reflection, and refraction",
        minScore: 60,
        category: "JEE Genius",
        subject: "Physics: Optics"
      },
      {
        id: "1.9",
        title: "Physics: Electromagnetism",
        status: "locked",
        description: "Electricity, magnetism, and electromagnetic waves",
        minScore: 60,
        category: "JEE Genius",
        subject: "Physics: Electromagnetism"
      },
      {
        id: "1.10",
        title: "Physics: Modern Physics",
        status: "locked",
        description: "Quantum mechanics and relativity",
        minScore: 60,
        category: "JEE Genius",
        subject: "Physics: Modern Physics"
      },
      {
        id: "1.11",
        title: "Chemistry: Organic Chemistry",
        status: "locked",
        description: "Organic compounds and reactions",
        minScore: 60,
        category: "JEE Genius",
        subject: "Chemistry: Organic Chemistry"
      },
      {
        id: "1.12",
        title: "Chemistry: Inorganic Chemistry",
        status: "locked",
        description: "Elements and their compounds",
        minScore: 60,
        category: "JEE Genius",
        subject: "Chemistry: Inorganic Chemistry"
      },
      {
        id: "1.13",
        title: "Chemistry: Physical Chemistry",
        status: "locked",
        description: "Physical principles in chemical systems",
        minScore: 60,
        category: "JEE Genius",
        subject: "Chemistry: Physical Chemistry"
      }
    ]
  },
  {
    id: "2",
    title: "NEET Mastery (Medical Entrance)",
    status: "locked",
    description: "Preparation for medical entrance examinations",
    minScore: 70,
    category: "NEET Mastery",
    subject: "All",
    subcategories: [
      {
        id: "2.1",
        title: "Biology: Human Physiology",
        status: "locked",
        description: "Study of human body systems",
        minScore: 70,
        category: "NEET Mastery",
        subject: "Biology: Human Physiology"
      },
      {
        id: "2.2",
        title: "Biology: Genetics",
        status: "locked",
        description: "Principles of inheritance and variation",
        minScore: 70,
        category: "NEET Mastery",
        subject: "Biology: Genetics"
      },
      {
        id: "2.3",
        title: "Biology: Evolution",
        status: "locked",
        description: "Evolutionary processes and history",
        minScore: 70,
        category: "NEET Mastery",
        subject: "Biology: Evolution"
      },
      {
        id: "2.4",
        title: "Biology: Ecology",
        status: "locked",
        description: "Interactions between organisms and environment",
        minScore: 70,
        category: "NEET Mastery",
        subject: "Biology: Ecology"
      },
      {
        id: "2.5",
        title: "Biology: Botany",
        status: "locked",
        description: "Study of plants and plant systems",
        minScore: 70,
        category: "NEET Mastery",
        subject: "Biology: Botany"
      },
      {
        id: "2.6",
        title: "Chemistry: Organic Chemistry",
        status: "locked",
        description: "Organic compounds and reactions",
        minScore: 70,
        category: "NEET Mastery",
        subject: "Chemistry: Organic Chemistry"
      },
      {
        id: "2.7",
        title: "Chemistry: Inorganic Chemistry",
        status: "locked",
        description: "Elements and their compounds",
        minScore: 70,
        category: "NEET Mastery",
        subject: "Chemistry: Inorganic Chemistry"
      },
      {
        id: "2.8",
        title: "Chemistry: Physical Chemistry",
        status: "locked",
        description: "Physical principles in chemical systems",
        minScore: 70,
        category: "NEET Mastery",
        subject: "Chemistry: Physical Chemistry"
      },
      {
        id: "2.9",
        title: "Physics: Mechanics",
        status: "locked",
        description: "Classical mechanics and kinematics",
        minScore: 70,
        category: "NEET Mastery",
        subject: "Physics: Mechanics"
      },
      {
        id: "2.10",
        title: "Physics: Thermodynamics",
        status: "locked",
        description: "Heat, energy, and thermodynamic processes",
        minScore: 70,
        category: "NEET Mastery",
        subject: "Physics: Thermodynamics"
      },
      {
        id: "2.11",
        title: "Physics: Optics",
        status: "locked",
        description: "Light, reflection, and refraction",
        minScore: 70,
        category: "NEET Mastery",
        subject: "Physics: Optics"
      },
      {
        id: "2.12",
        title: "Physics: Modern Physics",
        status: "locked",
        description: "Quantum mechanics and relativity",
        minScore: 70,
        category: "NEET Mastery",
        subject: "Physics: Modern Physics"
      }
    ]
  },
  {
    id: "3",
    title: "GATE Pathfinder",
    status: "locked",
    description: "Graduate Aptitude Test in Engineering preparation",
    minScore: 70,
    category: "GATE Pathfinder",
    subject: "All",
    subcategories: [
      {
        id: "3.1",
        title: "Computer Science: Data Structures",
        status: "locked",
        description: "Fundamental data structures and algorithms",
        minScore: 70,
        category: "GATE Pathfinder",
        subject: "Computer Science: Data Structures"
      },
      {
        id: "3.2",
        title: "Computer Science: Algorithms",
        status: "locked",
        description: "Algorithm design and analysis",
        minScore: 70,
        category: "GATE Pathfinder",
        subject: "Computer Science: Algorithms"
      },
      {
        id: "3.3",
        title: "Computer Science: Operating Systems",
        status: "locked",
        description: "OS concepts and implementation",
        minScore: 70,
        category: "GATE Pathfinder",
        subject: "Computer Science: Operating Systems"
      },
      {
        id: "3.4",
        title: "Computer Science: Networks",
        status: "locked",
        description: "Network architecture and protocols",
        minScore: 70,
        category: "GATE Pathfinder",
        subject: "Computer Science: Networks"
      },
      {
        id: "3.5",
        title: "Mechanical Engineering: Thermodynamics",
        status: "locked",
        description: "Thermal energy and its application",
        minScore: 70,
        category: "GATE Pathfinder",
        subject: "Mechanical Engineering: Thermodynamics"
      },
      {
        id: "3.6",
        title: "Mechanical Engineering: Fluid Mechanics",
        status: "locked",
        description: "Fluid behavior and properties",
        minScore: 70,
        category: "GATE Pathfinder",
        subject: "Mechanical Engineering: Fluid Mechanics"
      },
      {
        id: "3.7",
        title: "Mechanical Engineering: Strength of Materials",
        status: "locked",
        description: "Material properties under stress",
        minScore: 70,
        category: "GATE Pathfinder",
        subject: "Mechanical Engineering: Strength of Materials"
      },
      {
        id: "3.8",
        title: "Electrical Engineering: Circuits",
        status: "locked",
        description: "Electric circuit analysis and design",
        minScore: 70,
        category: "GATE Pathfinder",
        subject: "Electrical Engineering: Circuits"
      },
      {
        id: "3.9",
        title: "Electrical Engineering: Power Systems",
        status: "locked",
        description: "Electric power generation and transmission",
        minScore: 70,
        category: "GATE Pathfinder",
        subject: "Electrical Engineering: Power Systems"
      },
      {
        id: "3.10",
        title: "Electrical Engineering: Control Systems",
        status: "locked",
        description: "System control and stability",
        minScore: 70,
        category: "GATE Pathfinder",
        subject: "Electrical Engineering: Control Systems"
      },
      {
        id: "3.11",
        title: "Electrical Engineering: Signal Processing",
        status: "locked",
        description: "Signal analysis and processing techniques",
        minScore: 70,
        category: "GATE Pathfinder",
        subject: "Electrical Engineering: Signal Processing"
      },
      {
        id: "3.12",
        title: "Civil Engineering: Structural Engineering",
        status: "locked",
        description: "Analysis and design of structures",
        minScore: 70,
        category: "GATE Pathfinder",
        subject: "Civil Engineering: Structural Engineering"
      },
      {
        id: "3.13",
        title: "Civil Engineering: Geotechnical Engineering",
        status: "locked",
        description: "Soil mechanics and foundation design",
        minScore: 70,
        category: "GATE Pathfinder",
        subject: "Civil Engineering: Geotechnical Engineering"
      },
      {
        id: "3.14",
        title: "Civil Engineering: Hydraulics",
        status: "locked",
        description: "Hydraulic engineering principles",
        minScore: 70,
        category: "GATE Pathfinder",
        subject: "Civil Engineering: Hydraulics"
      },
      {
        id: "3.15",
        title: "Electronics & Communication: Digital Circuits",
        status: "locked",
        description: "Design and analysis of digital circuits",
        minScore: 70,
        category: "GATE Pathfinder",
        subject: "Electronics & Communication: Digital Circuits"
      },
      {
        id: "3.16",
        title: "Electronics & Communication: Analog Electronics",
        status: "locked",
        description: "Analog circuit design and applications",
        minScore: 70,
        category: "GATE Pathfinder",
        subject: "Electronics & Communication: Analog Electronics"
      },
      {
        id: "3.17",
        title: "Electronics & Communication: Communication Systems",
        status: "locked",
        description: "Communication theory and techniques",
        minScore: 70,
        category: "GATE Pathfinder",
        subject: "Electronics & Communication: Communication Systems"
      }
    ]
  },
  {
    id: "4",
    title: "UPSC Visionary (Civil Services Exam)",
    status: "locked",
    description: "Preparation for civil services examinations",
    minScore: 75,
    category: "UPSC Visionary",
    subject: "All",
    subcategories: [
      {
        id: "4.1",
        title: "General Studies: Indian Polity",
        status: "locked",
        description: "Constitutional and political systems of India",
        minScore: 75,
        category: "UPSC Visionary",
        subject: "General Studies: Indian Polity"
      },
      {
        id: "4.2",
        title: "General Studies: Economy",
        status: "locked",
        description: "Indian and global economic concepts",
        minScore: 75,
        category: "UPSC Visionary",
        subject: "General Studies: Economy"
      },
      {
        id: "4.3",
        title: "General Studies: Geography",
        status: "locked",
        description: "Physical, human, and economic geography",
        minScore: 75,
        category: "UPSC Visionary",
        subject: "General Studies: Geography"
      },
      {
        id: "4.4",
        title: "General Studies: History",
        status: "locked",
        description: "Indian and world history",
        minScore: 75,
        category: "UPSC Visionary",
        subject: "General Studies: History"
      },
      {
        id: "4.5",
        title: "General Studies: Science & Tech",
        status: "locked",
        description: "Scientific concepts and technological developments",
        minScore: 75,
        category: "UPSC Visionary",
        subject: "General Studies: Science & Tech"
      },
      {
        id: "4.6",
        title: "CSAT: Logical Reasoning",
        status: "locked",
        description: "Analytical and logical reasoning skills",
        minScore: 75,
        category: "UPSC Visionary",
        subject: "CSAT: Logical Reasoning"
      },
      {
        id: "4.7",
        title: "CSAT: Data Interpretation",
        status: "locked",
        description: "Analysis and interpretation of data",
        minScore: 75,
        category: "UPSC Visionary",
        subject: "CSAT: Data Interpretation"
      },
      {
        id: "4.8",
        title: "CSAT: Comprehension",
        status: "locked",
        description: "Reading comprehension skills",
        minScore: 75,
        category: "UPSC Visionary",
        subject: "CSAT: Comprehension"
      },
      {
        id: "4.9",
        title: "Essay Writing: Current Affairs",
        status: "locked",
        description: "Essay writing on contemporary issues",
        minScore: 75,
        category: "UPSC Visionary",
        subject: "Essay Writing: Current Affairs"
      },
      {
        id: "4.10",
        title: "Essay Writing: Analytical Writing",
        status: "locked",
        description: "Analytical and critical essay writing",
        minScore: 75,
        category: "UPSC Visionary",
        subject: "Essay Writing: Analytical Writing"
      }
    ]
  },
  {
    id: "5",
    title: "Govt Exam Wizard",
    status: "locked",
    description: "Preparation for various government exams",
    minScore: 65,
    category: "Govt Exam Wizard",
    subject: "All",
    subcategories: [
      {
        id: "5.1",
        title: "Quantitative Aptitude: Arithmetic",
        status: "locked",
        description: "Basic mathematical operations and concepts",
        minScore: 65,
        category: "Govt Exam Wizard",
        subject: "Quantitative Aptitude: Arithmetic"
      },
      {
        id: "5.2",
        title: "Quantitative Aptitude: Algebra",
        status: "locked",
        description: "Algebraic equations and expressions",
        minScore: 65,
        category: "Govt Exam Wizard",
        subject: "Quantitative Aptitude: Algebra"
      },
      {
        id: "5.3",
        title: "Quantitative Aptitude: Probability",
        status: "locked",
        description: "Probability theory and applications",
        minScore: 65,
        category: "Govt Exam Wizard",
        subject: "Quantitative Aptitude: Probability"
      },
      {
        id: "5.4",
        title: "Quantitative Aptitude: Geometry",
        status: "locked",
        description: "Geometric shapes and properties",
        minScore: 65,
        category: "Govt Exam Wizard",
        subject: "Quantitative Aptitude: Geometry"
      },
      {
        id: "5.5",
        title: "Reasoning Ability: Logical Reasoning",
        status: "locked",
        description: "Logical analysis and problem-solving",
        minScore: 65,
        category: "Govt Exam Wizard",
        subject: "Reasoning Ability: Logical Reasoning"
      },
      {
        id: "5.6",
        title: "Reasoning Ability: Puzzles",
        status: "locked",
        description: "Puzzle-solving techniques",
        minScore: 65,
        category: "Govt Exam Wizard",
        subject: "Reasoning Ability: Puzzles"
      },
      {
        id: "5.7",
        title: "Reasoning Ability: Verbal & Non-Verbal Reasoning",
        status: "locked",
        description: "Verbal and visual reasoning skills",
        minScore: 65,
        category: "Govt Exam Wizard",
        subject: "Reasoning Ability: Verbal & Non-Verbal Reasoning"
      },
      {
        id: "5.8",
        title: "General Awareness: Indian Economy",
        status: "locked",
        description: "Economic concepts and current affairs",
        minScore: 65,
        category: "Govt Exam Wizard",
        subject: "General Awareness: Indian Economy"
      },
      {
        id: "5.9",
        title: "General Awareness: Science & Technology",
        status: "locked",
        description: "Scientific innovations and technology",
        minScore: 65,
        category: "Govt Exam Wizard",
        subject: "General Awareness: Science & Technology"
      },
      {
        id: "5.10",
        title: "General Awareness: Current Affairs",
        status: "locked",
        description: "Recent events and developments",
        minScore: 65,
        category: "Govt Exam Wizard",
        subject: "General Awareness: Current Affairs"
      },
      {
        id: "5.11",
        title: "English Language: Grammar",
        status: "locked",
        description: "English grammar rules and usage",
        minScore: 65,
        category: "Govt Exam Wizard",
        subject: "English Language: Grammar"
      },
      {
        id: "5.12",
        title: "English Language: Reading Comprehension",
        status: "locked",
        description: "Understanding and analyzing written text",
        minScore: 65,
        category: "Govt Exam Wizard",
        subject: "English Language: Reading Comprehension"
      },
      {
        id: "5.13",
        title: "English Language: Vocabulary",
        status: "locked",
        description: "Word meanings and usage",
        minScore: 65,
        category: "Govt Exam Wizard",
        subject: "English Language: Vocabulary"
      }
    ]
  },
  {
    id: "6",
    title: "Data Science Ace",
    status: "locked",
    description: "Advanced data science and AI concepts",
    minScore: 80,
    category: "Data Science Ace",
    subject: "All",
    subcategories: [
      {
        id: "6.1",
        title: "Mathematics for AI: Linear Algebra",
        status: "locked",
        description: "Vectors, matrices, and linear transformations",
        minScore: 80,
        category: "Data Science Ace",
        subject: "Mathematics for AI: Linear Algebra"
      },
      {
        id: "6.2",
        title: "Mathematics for AI: Probability",
        status: "locked",
        description: "Probability theory for data science",
        minScore: 80,
        category: "Data Science Ace",
        subject: "Mathematics for AI: Probability"
      },
      {
        id: "6.3",
        title: "Mathematics for AI: Statistics",
        status: "locked",
        description: "Statistical methods for data analysis",
        minScore: 80,
        category: "Data Science Ace",
        subject: "Mathematics for AI: Statistics"
      },
      {
        id: "6.4",
        title: "Machine Learning: Supervised Learning",
        status: "locked",
        description: "Algorithms for labeled data",
        minScore: 80,
        category: "Data Science Ace",
        subject: "Machine Learning: Supervised Learning"
      },
      {
        id: "6.5",
        title: "Machine Learning: Unsupervised Learning",
        status: "locked",
        description: "Clustering and dimensionality reduction",
        minScore: 80,
        category: "Data Science Ace",
        subject: "Machine Learning: Unsupervised Learning"
      },
      {
        id: "6.6",
        title: "Machine Learning: Neural Networks",
        status: "locked",
        description: "Neural network architectures and training",
        minScore: 80,
        category: "Data Science Ace",
        subject: "Machine Learning: Neural Networks"
      },
      {
        id: "6.7",
        title: "Big Data & Analytics: Hadoop",
        status: "locked",
        description: "Distributed data processing with Hadoop",
        minScore: 80,
        category: "Data Science Ace",
        subject: "Big Data & Analytics: Hadoop"
      },
      {
        id: "6.8",
        title: "Big Data & Analytics: Spark",
        status: "locked",
        description: "Fast analytics with Apache Spark",
        minScore: 80,
        category: "Data Science Ace",
        subject: "Big Data & Analytics: Spark"
      },
      {
        id: "6.9",
        title: "Big Data & Analytics: Data Engineering Fundamentals",
        status: "locked",
        description: "Data pipeline design and implementation",
        minScore: 80,
        category: "Data Science Ace",
        subject: "Big Data & Analytics: Data Engineering Fundamentals"
      }
    ]
  },
  {
    id: "7",
    title: "Coding Maestro",
    status: "locked",
    description: "Programming and algorithm expertise",
    minScore: 75,
    category: "Coding Maestro",
    subject: "All",
    subcategories: [
      {
        id: "7.1",
        title: "Programming Languages: Python",
        status: "locked",
        description: "Python programming concepts and applications",
        minScore: 75,
        category: "Coding Maestro",
        subject: "Programming Languages: Python"
      },
      {
        id: "7.2",
        title: "Programming Languages: Java",
        status: "locked",
        description: "Java programming and object-oriented concepts",
        minScore: 75,
        category: "Coding Maestro",
        subject: "Programming Languages: Java"
      },
      {
        id: "7.3",
        title: "Programming Languages: C++",
        status: "locked",
        description: "C++ programming and memory management",
        minScore: 75,
        category: "Coding Maestro",
        subject: "Programming Languages: C++"
      },
      {
        id: "7.4",
        title: "Programming Languages: JavaScript",
        status: "locked",
        description: "Web programming with JavaScript",
        minScore: 75,
        category: "Coding Maestro",
        subject: "Programming Languages: JavaScript"
      },
      {
        id: "7.5",
        title: "Data Structures & Algorithms: Graphs",
        status: "locked",
        description: "Graph theory and algorithms",
        minScore: 75,
        category: "Coding Maestro",
        subject: "Data Structures & Algorithms: Graphs"
      },
      {
        id: "7.6",
        title: "Data Structures & Algorithms: Trees",
        status: "locked",
        description: "Tree structures and traversal algorithms",
        minScore: 75,
        category: "Coding Maestro",
        subject: "Data Structures & Algorithms: Trees"
      },
      {
        id: "7.7",
        title: "Data Structures & Algorithms: Dynamic Programming",
        status: "locked",
        description: "Optimization through dynamic programming",
        minScore: 75,
        category: "Coding Maestro",
        subject: "Data Structures & Algorithms: Dynamic Programming"
      },
      {
        id: "7.8",
        title: "Competitive Coding: Code Optimization",
        status: "locked",
        description: "Techniques for efficient code",
        minScore: 75,
        category: "Coding Maestro",
        subject: "Competitive Coding: Code Optimization"
      },
      {
        id: "7.9",
        title: "Competitive Coding: Problem-Solving Strategies",
        status: "locked",
        description: "Approaches to solve complex problems",
        minScore: 75,
        category: "Coding Maestro",
        subject: "Competitive Coding: Problem-Solving Strategies"
      }
    ]
  },
  {
    id: "8",
    title: "CyberSecure Pro",
    status: "locked",
    description: "Cybersecurity concepts and practices",
    minScore: 80,
    category: "CyberSecure Pro",
    subject: "All",
    subcategories: [
      {
        id: "8.1",
        title: "Ethical Hacking: Penetration Testing",
        status: "locked",
        description: "Security testing methodologies",
        minScore: 80,
        category: "CyberSecure Pro",
        subject: "Ethical Hacking: Penetration Testing"
      },
      {
        id: "8.2",
        title: "Ethical Hacking: Network Security",
        status: "locked",
        description: "Securing network infrastructure",
        minScore: 80,
        category: "CyberSecure Pro",
        subject: "Ethical Hacking: Network Security"
      },
      {
        id: "8.3",
        title: "Ethical Hacking: Cryptography",
        status: "locked",
        description: "Encryption methods and applications",
        minScore: 80,
        category: "CyberSecure Pro",
        subject: "Ethical Hacking: Cryptography"
      },
      {
        id: "8.4",
        title: "Cyber Threats: Malware Analysis",
        status: "locked",
        description: "Analyzing malicious software",
        minScore: 80,
        category: "CyberSecure Pro",
        subject: "Cyber Threats: Malware Analysis"
      },
      {
        id: "8.5",
        title: "Cyber Threats: Cyber Forensics",
        status: "locked",
        description: "Digital evidence collection and analysis",
        minScore: 80,
        category: "CyberSecure Pro",
        subject: "Cyber Threats: Cyber Forensics"
      },
      {
        id: "8.6",
        title: "Cyber Threats: Security Policies",
        status: "locked",
        description: "Creating and implementing security policies",
        minScore: 80,
        category: "CyberSecure Pro",
        subject: "Cyber Threats: Security Policies"
      },
      {
        id: "8.7",
        title: "Blockchain Security: Smart Contracts",
        status: "locked",
        description: "Security of blockchain applications",
        minScore: 80,
        category: "CyberSecure Pro",
        subject: "Blockchain Security: Smart Contracts"
      },
      {
        id: "8.8",
        title: "Blockchain Security: Consensus Mechanisms",
        status: "locked",
        description: "Blockchain validation and consensus",
        minScore: 80,
        category: "CyberSecure Pro",
        subject: "Blockchain Security: Consensus Mechanisms"
      }
    ]
  },
  {
    id: "9",
    title: "Cloud Architect",
    status: "locked",
    description: "Cloud computing and architecture",
    minScore: 75,
    category: "Cloud Architect",
    subject: "All",
    subcategories: [
      {
        id: "9.1",
        title: "Cloud Computing: AWS",
        status: "locked",
        description: "Amazon Web Services architecture",
        minScore: 75,
        category: "Cloud Architect",
        subject: "Cloud Computing: AWS"
      },
      {
        id: "9.2",
        title: "Cloud Computing: Azure",
        status: "locked",
        description: "Microsoft Azure platform and services",
        minScore: 75,
        category: "Cloud Architect",
        subject: "Cloud Computing: Azure"
      },
      {
        id: "9.3",
        title: "Cloud Computing: Google Cloud Basics",
        status: "locked",
        description: "Google Cloud Platform fundamentals",
        minScore: 75,
        category: "Cloud Architect",
        subject: "Cloud Computing: Google Cloud Basics"
      },
      {
        id: "9.4",
        title: "DevOps: CI/CD Pipelines",
        status: "locked",
        description: "Continuous integration and deployment",
        minScore: 75,
        category: "Cloud Architect",
        subject: "DevOps: CI/CD Pipelines"
      },
      {
        id: "9.5",
        title: "DevOps: Kubernetes",
        status: "locked",
        description: "Container orchestration with Kubernetes",
        minScore: 75,
        category: "Cloud Architect",
        subject: "DevOps: Kubernetes"
      },
      {
        id: "9.6",
        title: "DevOps: Docker",
        status: "locked",
        description: "Containerization with Docker",
        minScore: 75,
        category: "Cloud Architect",
        subject: "DevOps: Docker"
      },
      {
        id: "9.7",
        title: "Networking & Security: Firewalls",
        status: "locked",
        description: "Network security and firewalls",
        minScore: 75,
        category: "Cloud Architect",
        subject: "Networking & Security: Firewalls"
      },
      {
        id: "9.8",
        title: "Networking & Security: Cloud Security Architecture",
        status: "locked",
        description: "Securing cloud infrastructure",
        minScore: 75,
        category: "Cloud Architect",
        subject: "Networking & Security: Cloud Security Architecture"
      }
    ]
  },
  {
    id: "10",
    title: "AI & ML Prodigy",
    status: "locked",
    description: "Advanced artificial intelligence and machine learning",
    minScore: 85,
    category: "AI & ML Prodigy",
    subject: "All",
    subcategories: [
      {
        id: "10.1",
        title: "Deep Learning: Convolutional Neural Networks",
        status: "locked",
        description: "CNNs for image processing",
        minScore: 85,
        category: "AI & ML Prodigy",
        subject: "Deep Learning: Convolutional Neural Networks"
      },
      {
        id: "10.2",
        title: "Deep Learning: Recurrent Neural Networks",
        status: "locked",
        description: "RNNs for sequential data",
        minScore: 85,
        category: "AI & ML Prodigy",
        subject: "Deep Learning: Recurrent Neural Networks"
      },
      {
        id: "10.3",
        title: "NLP & Computer Vision: Transformer Models",
        status: "locked",
        description: "Attention mechanisms and transformers",
        minScore: 85,
        category: "AI & ML Prodigy",
        subject: "NLP & Computer Vision: Transformer Models"
      },
      {
        id: "10.4",
        title: "NLP & Computer Vision: Object Detection",
        status: "locked",
        description: "Identifying objects in images",
        minScore: 85,
        category: "AI & ML Prodigy",
        subject: "NLP & Computer Vision: Object Detection"
      },
      {
        id: "10.5",
        title: "AI Ethics & Fairness: Bias Reduction",
        status: "locked",
        description: "Reducing bias in AI systems",
        minScore: 85,
        category: "AI & ML Prodigy",
        subject: "AI Ethics & Fairness: Bias Reduction"
      },
      {
        id: "10.6",
        title: "AI Ethics & Fairness: Interpretability in AI",
        status: "locked",
        description: "Making AI models explainable",
        minScore: 85,
        category: "AI & ML Prodigy",
        subject: "AI Ethics & Fairness: Interpretability in AI"
      }
    ]
  }
];
